(function () {
  'use strict';

  /* @ngdoc object
   * @name main.dades
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.dades', [
      'ui.router'
    ]);
}());
